import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'

import GooglePlacesAutocompleteField from '@/components/formik/fields/GooglePlacesAutocompleteField'
import TextField from '@/components/formik/fields/TextField'
import WeeklyScheduleBuilder from '../components/WeeklyScheduleBuilder'

export default function LocationScheduleStep() {
  const { t } = useTranslation()

  return (
    <Stack spacing={3}>
      <Stack spacing={0.5}>
        <Typography variant="h6">
          {t('page.meetingLink.wizard.location.title', 'Where and when?')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('page.meetingLink.wizard.location.subtitle', 'Set your office address and schedule')}
        </Typography>
      </Stack>

      <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2, bgcolor: 'grey.50' }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <LocationOnOutlinedIcon color="primary" fontSize="small" />
          <Typography variant="subtitle2">
            {t('page.meetingLink.wizard.location.addressLabel', 'Office address')}
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <GooglePlacesAutocompleteField
            label={t('field.address.label')}
            name="address"
          />
          <TextField
            fullWidth
            label={t('field.addressExtra.label')}
            name="additionalAddress"
            maxRows={2}
            minRows={1}
            multiline
            placeholder={t('field.addressExtra.placeholder')}
            size="small"
          />
        </Stack>
      </Box>

      <Divider />

      <Typography variant="subtitle2">
        {t('page.meetingLink.wizard.location.scheduleLabel', 'Weekly schedule')}
      </Typography>

      <WeeklyScheduleBuilder />
    </Stack>
  )
}
